import React, {useState} from 'react';
import {SerializedError, unwrapResult} from '@reduxjs/toolkit';
import {
  backToPrevScreen,
  createUser,
  enterCode,
  selectScreen,
} from 'auth/authSlice';
import Button from 'components/Button';
import MobileCodeCommon from 'components/MobileCodeCommon/MobileCodeCommon';
import {useAppSelector} from 'hooks';
import {EnterCodeScreen} from 'auth/authApi';
import commonStyle from 'components/common.module.css';
import {maskEmail} from 'utils/maskEmailOrPhone';
import cx from 'clsx';
import {useAppDispatch} from 'store';

import style from './VerificationCode.module.css';

const VerificationCode: React.FC = () => {
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const dispatch = useAppDispatch();
  const screen = useAppSelector(selectScreen);

  const [loading, setLoading] = useState(false);

  const {resend = () => {}, email = '', backScreen} = screen as EnterCodeScreen;

  const handleClickResend = () => {
    resend();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    try {
      const enterCodeResult = await dispatch(
        enterCode({screen: screen as EnterCodeScreen, code}),
      );
      const createUserResult = await dispatch(createUser());

      unwrapResult(enterCodeResult);
      unwrapResult(createUserResult);
    } catch (e: unknown) {
      const err = e as SerializedError;
      const errorText =
        err?.message === 'Wrong email or verification code.'
          ? 'Wrong verification code'
          : err?.message || 'Unknown error';
      setErrorMessage(errorText);
    }

    setLoading(false);
  };

  const handleClickBack = () => {
    if (backScreen) {
      dispatch(backToPrevScreen({backScreen}));
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className={style.form}>
        <div className={cx(style.subtitle, style.subtitle_margin)}>
          For security reasons we need to verify your identity, please check
          your email for a secure code
        </div>
        <div className={cx(commonStyle.text, style.text_margin)}>
          Code sent to email {maskEmail(email)}
        </div>

        <MobileCodeCommon
          type='SIGNUP'
          onResend={handleClickResend}
          value={code}
          onChange={value => setCode(value)}
          errorMessage={errorMessage}
        />
        <Button
          disabled={code.length !== 6}
          loading={loading}
          className={cx(commonStyle.button, style.submit)}
          type='submit'
        >
          Create account
        </Button>
        {backScreen && (
          <Button
            className={cx(commonStyle.button, commonStyle.marginTop)}
            onClick={handleClickBack}
            variant='border'
          >
            BACK
          </Button>
        )}
      </form>
    </>
  );
};

export default VerificationCode;
